/*
 * Copyright (c) 2019 Promontory Interfinancial Network, LLC
 */
export enum RegistrationNotification {
  customer_already_registered = 'CUSTOMER_ALREADY_REGISTERED',
  username_already_exists = 'USERNAME_ALREADY_EXISTS',
  email_already_exists = 'EMAIL_ALREADY_EXISTS',
  data_validation_error = 'DATA_VALIDATION_ERROR',
  self_registration_disabled = 'SELF_REGISTRATION_DISABLED',
  resend_confirmation_mail_success = 'RESEND_CONFIRMATION_MAIL_SUCCESS',
  limit_exceeded_exception = 'LIMIT_EXCEEDED_EXCEPTION',
  try_again_later = 'TRY_AGAIN_LATER'
}
